"use strict";
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "DefaultImage", {
  enumerable: true,
  get: function () {
    return _Image.default;
  }
});
exports.default = void 0;
var _Image = _interopRequireDefault(require("./Image"));
var _withClientTheme = _interopRequireDefault(require("../utils/theming/with-client-theme"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Exporting the unwrapped component separately for react-docgen to extract info for docsite

const ClientThemedImage = (0, _withClientTheme.default)(_Image.default);
var _default = exports.default = ClientThemedImage;